import {
  Button,
  createStyles,
  Dialog,
  Theme,
  WithStyles,
  withStyles,
  Drawer,
  Divider,
  AppBar,
  CssBaseline,
  Toolbar,
  Typography,
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Grid,
  ButtonBase,
  Tabs,
  Tab,
  List,
  IconButton,
  ThemeProvider,
  Chip,
  ListItemIcon,
} from "@material-ui/core";
import deepOrange from "@material-ui/core/colors/deepOrange";
import * as React from "react";
import EyeViewIcon from "@material-ui/icons/Visibility";
import ImageIcon from "@material-ui/icons/Image";
import DialpadIcon from "@material-ui/icons/Dialpad";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import CalendarIcon from "@material-ui/icons/CalendarToday";
import ViewSignatureDialog from "./ViewSignatureDialog";
import {
  getInspectionLabel,
  getMomentDate,
  getMomentTime,
  getMomentDateTime,
  convertTextToTitleCase,
} from "../constants/constants";
import TabPanel from "../components/TabPanel";
import DisplayItemComponent from "../components/DisplayItemComponent";
import { AssetsService } from "../services/AssetsService";
import LoadingComponents from "../components/LoadingComponents";
import { PhotoService } from "../services/PhotoService";
import imagePlacholder from "../assets/images/image-placeholder.png";
import { defaultTheme } from "../utils/theme";
import AddInputDialog from "./AddInputDialog";
import { EventEmitter } from "../events/EventEmitter";
import { ActionedService } from "../services/ActionedService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import ActivitiesTableComponent from "../components/ActivitiesTableComponent";
import ViewImageDialog from "./ViewImageDialog";
import emptyTrash from "../assets/images/empty_trash.png";
const drawerWidth = "30%";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    tabRoot: {
      flexGrow: 1,
    },
    focusVisible: {},
    appBar: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    img: {
      margin: "auto",
      display: "block",
      maxWidth: "80%",
      maxHeight: "80%",
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    drawerPaper: {
      marginTop: 64,
      width: drawerWidth,
    },
    image: {
      width: 128,
      height: 128,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: 5,
    },
    media: {
      height: 200,
      width: 300,
      padding: 10,
      alignSelf: "center",
    },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    fab: {
      position: "fixed",
      zIndex: 100,
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    section3: {
      margin: theme.spacing(3, 3, 3),
    },
    chip: {
      margin: theme.spacing(0.5),
      color: theme.palette.getContrastText(deepOrange[500]),
    },
    imageTitle: {
      position: "relative",
      padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${
        theme.spacing(1) + 6
      }px`,
    },
    imageMarked: {
      height: 3,
      width: 18,
      backgroundColor: theme.palette.common.white,
      position: "absolute",
      bottom: -2,
      left: "calc(50% - 9px)",
      transition: theme.transitions.create("opacity"),
    },
    signChip: {
      padding: 5,
      margin: 5,
      width: 120,
      height: 44,
    },
    imageButton: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.common.white,
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      marginLeft: "30%",
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  inspectionData: any;
  handleClose: any;
  company: any;
}
class ViewInspectionDialog extends React.Component<Props> {
  state = {
    signatures: Array<any>(),
    openSignatureDialog: false,
    openEditDialog: false,
    editQuestionItem: { question: "", _id: "" },
    selectedSignature: {},
    selectedTab: 0,
    isLoading: false,
    openViewImage: false,
    selectImageToView: {},
  };

  componentDidMount = async () => {
    const { inspectionData } = this.props;
    if (inspectionData.inspection) {
      let signitories = inspectionData.inspection.signotoriesItems;
      let inspectionsItems = inspectionData.inspection.inspectionsItems;
      let breakdowns = inspectionData.inspection.breakdowns;
      if (signitories) {
        // for (var i = 0; i < signitories.length; i++) {
        //   let signatureItem = signitories[i];
        //   if (signatureItem.value && signatureItem.value.signatureValue) {
        // signatureItem = await this.downloadSignatoriesItemsImages(
        //   signatureItem
        // );
        //   }
        // }
      }
      if (inspectionsItems) {
        this.downloadInspectionItemsAssets(inspectionsItems);
      }
      this.downloadBreakdownAssets(breakdowns);
    }
  };

  componentDidUpdate = async (prevProps: any, prevState: any) => {
    if (prevProps.inspectionData !== this.props.inspectionData) {
      const { inspectionData } = this.props;
      let signitories = inspectionData.inspection.signotoriesItems;
      let inspectionsItems = inspectionData.inspection.inspectionsItems;
      let breakdowns = inspectionData.inspection.breakdowns;
      let standings = inspectionData.inspection.standings;
      if (signitories) {
        let photoService: PhotoService = new PhotoService();
        for (var i = 0; i < signitories.length; i++) {
          let signatureItem = signitories[i];
          if (signatureItem.value && signatureItem.value.signatureValue) {
            let signatureValue = signatureItem.value.signatureValue;
            photoService
              .downloadQuestionPhoto(signatureValue._id)
              .then((resp: any) => {
                if (resp && resp.data) {
                  let mData = resp.data;
                  signatureItem.value.signatureValue = mData;
                }
              });
          }
        }
      }
      if (inspectionData.inspection && inspectionData.inspection.imageItem) {
        this.downloadQuestionAsset(inspectionData.inspection.imageItem);
      }
      if (inspectionsItems) {
        this.downloadInspectionItemsAssets(inspectionsItems);
      }
      this.downloadBreakdownAssets(breakdowns);
      this.downloadStandingAssets(standings);
    }
  };

  downloadInspectionItemsAssets = async (inspectionsItems: any) => {
    if (!inspectionsItems) {
      return;
    }
    for (var k = 0; k < inspectionsItems.length; k++) {
      let inspectionItem = inspectionsItems[k];
      if (inspectionItem.questions) {
        for (var n = 0; n < inspectionItem.questions.length; n++) {
          let questionItem = inspectionItem.questions[n];
          if (questionItem.value && questionItem.value.images) {
            for (var m = 0; m < questionItem.value.images.length; m++) {
              let imageItem = questionItem.value.images[m];
              this.downloadQuestionPhoto(imageItem._id).then((resp) => {
                imageItem.imageId = imageItem._id;
                imageItem.base64 = resp.data;
              });
            }
          }
        }
      }
      this.downloadQuestionAsset(inspectionItem.imageItem);
    }
  };

  downloadBreakdownAssets = (breakdowns: any) => {
    if (!breakdowns) {
      return;
    }
    breakdowns.map((breakdownItem: any) => {
      this.downloadBreakdownImages(breakdownItem);
      return null;
    });
  };
  downloadStandingAssets = (standings: any) => {
    if (!standings) {
      return;
    }
    standings.map((standingItem: any) => {
      this.downloadStandingImages(standingItem);
      return null;
    });
  };
  downloadSignatoriesItemsImages = async (signatureItem: any) => {
    let photoService: PhotoService = new PhotoService();
    let signatureValue = signatureItem.value.signatureValue;
    let resp = await photoService.downloadQuestionPhoto(signatureValue._id);
    if (resp && resp.data) {
      let mData = resp.data;
      signatureItem.value.signatureValue = mData;
    }
    return signatureItem;
  };
  downloadBreakdownImages = (breakDownItem: any) => {
    if (!breakDownItem) {
      return null;
    }
    if (breakDownItem.images && breakDownItem.images.length > 0) {
      for (var p = 0; p < breakDownItem.images.length; p++) {
        let imageItem = breakDownItem.images[p];
        this.downloadQuestionPhoto(imageItem._id).then((resp) => {
          if (resp && resp.data) {
            imageItem.imageId = imageItem._id;
            imageItem.base64 = resp.data;
          }
        });
      }
    }
    if (
      breakDownItem.artisanPersons &&
      breakDownItem.artisanPersons.length > 0
    ) {
      let artisanPersons = breakDownItem.artisanPersons;
      for (var h = 0; h < artisanPersons.length; h++) {
        let artisanPerson = artisanPersons[h];
        if (
          artisanPerson &&
          artisanPerson.images &&
          artisanPerson.images.length > 0
        ) {
          for (var v = 0; v < artisanPerson.images.length; v++) {
            let imageItem = artisanPerson.images[v];
            this.downloadQuestionPhoto(imageItem._id).then((resp) => {
              if (resp && resp.data) {
                imageItem.imageId = imageItem._id;
                imageItem.base64 = resp.data;
              }
            });
          }
        }
      }
    }
  };

  downloadStandingImages = (standingItem: any) => {
    if (!standingItem) {
      return null;
    }
    if (standingItem.images && standingItem.images.length > 0) {
      for (var v = 0; v < standingItem.images.length; v++) {
        let imageItem = standingItem.images[v];
        this.downloadQuestionPhoto(imageItem._id).then((resp) => {
          if (resp && resp.data) {
            imageItem.imageId = imageItem._id;
            imageItem.base64 = resp.data;
          }
        });
      }
    }
  };

  downloadQuestionPhoto = async (imageId: any) => {
    let photoService: PhotoService = new PhotoService();
    this.setState({
      isLoading: false,
    });
    return photoService.downloadQuestionPhoto(imageId);
  };
  downloadQuestionAsset = (imageItem: any) => {
    let assetsService: AssetsService = new AssetsService();
    this.setState({
      isLoading: true,
    });
    assetsService.getAsset(imageItem.filename).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.data) {
        imageItem.base64 = resp.data;
      }
    });
  };

  getEquipmentName = () => {
    const { inspectionData } = this.props;
    let equipmentValue = inspectionData.inspection.equipment;
    if (!equipmentValue) {
      var nameArr = inspectionData.inspection.name.split(" ");
      if (nameArr.length > 0) {
        equipmentValue = nameArr[0];
      } else {
        inspectionData.inspection.headerItems.map((headerItem: any) => {
          if (headerItem.title === "Equipment Name") {
            equipmentValue = headerItem.value;
          }
          return null;
        });
      }
    }
    return equipmentValue;
  };

  getLicenseDetailsItem = (licenseDetails: any, headerItem: any) => {
    let equipmentValue = this.getEquipmentName();
    let value = null;
    licenseDetails.map((licenseItem: any) => {
      let name = equipmentValue.replace("-", " ");
      if (licenseItem.authorizedEquipment.label === equipmentValue) {
        value = new Date(licenseItem[headerItem.licenseDetail]);
      } else if (licenseItem.authorizedEquipment.label.includes(name)) {
        value = new Date(licenseItem[headerItem.licenseDetail]);
      } else {
        return null;
      }
      return null;
    });
    return value;
  };

  getValueByType = (type: string, value: any, thr?: any) => {
    switch (type.toUpperCase()) {
      case "DATE":
        if (
          (value instanceof Object && thr.title.includes("Licence")) ||
          thr.title.includes("License")
        ) {
          let mDate = this.getLicenseDetailsItem(value, thr);
          let mDateValue = mDate ? mDate : "";
          return getMomentDate(mDateValue);
        } else {
          return getMomentDate(value);
        }
      case "TEXT":
        return value;
      case "NUMBER":
        return value;
      default: {
        return value;
      }
    }
  };
  getIcon = (type: string) => {
    switch (type) {
      case "Date":
        return <CalendarIcon />;
      case "Text":
        return <TextFieldsIcon />;
      case "Number":
        return <DialpadIcon />;
      default: {
      }
    }
  };
  getBase64 = (signatureItemArg: any) => {
    if (!signatureItemArg) {
      return "";
    }
    let base64 = "";
    this.state.signatures.map((signatureItem: any) => {
      if (signatureItemArg._id === signatureItem.signatureId) {
        base64 = signatureItem.base64;
      }
      return null;
    });
    return base64;
  };
  handleClose = () => {
    this.setState({
      openSignatureDialog: false,
      openEditDialog: false,
      openViewImage: false,
      selectImageToView: {},
    });
  };
  handleViewSignature = (base64: any, signatureItem: any) => {
    this.setState({
      selectedSignature: { base64: base64, signatureItem: signatureItem },
      openSignatureDialog: true,
    });
  };
  handleOnMenuItemClicked = (option: any, questionItem: any) => {
    switch (option) {
      case "Edit":
        this.setState({
          openEditDialog: true,
          editQuestionItem: questionItem,
        });
        break;
      default: {
        console.log("option not implemented");
      }
    }
  };
  handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ selectedTab: newValue });
  };
  renderSignatureDialog = () => {
    return (
      <ViewSignatureDialog
        dialogTitle={"Signature"}
        onClose={this.handleClose}
        open={this.state.openSignatureDialog}
        signature={this.state.selectedSignature}
      />
    );
  };
  handleSaveClicked = (value: any) => {
    const { inspectionData } = this.props;
    const { inspectionsItems } = inspectionData.inspection;
    if (this.state.editQuestionItem) {
      inspectionsItems.map((questionItem: any) => {
        questionItem.questions.map((question: any) => {
          if (question._id === this.state.editQuestionItem._id) {
            if (question.value) {
              question.value.notes = value;
            }
          }
          return null;
        });

        return null;
      });
      let actionedService: ActionedService = new ActionedService();
      EventEmitter.dispatch(EventEmitter.events.START_LOADING_REQUEST, {});
      actionedService.updateActionedInspection(inspectionData).then((resp) => {
        EventEmitter.dispatch(EventEmitter.events.STOP_LOADING_REQUEST, {});
        if (resp && resp.success) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Updated Successfully",
          });
          this.handleClose();
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
      });
    }
  };

  renderEditDialog = () => {
    return (
      <AddInputDialog
        dialogTitle={this.state.editQuestionItem.question}
        questionItem={this.state.editQuestionItem}
        onClose={this.handleClose}
        onSave={this.handleSaveClicked}
        open={this.state.openEditDialog}
      />
    );
  };
  renderViewImageDialog = () => {
    return (
      <ViewImageDialog
        open={this.state.openViewImage}
        dialogTitle={"Viewing full image"}
        imageItem={this.state.selectImageToView}
        onClose={this.handleClose}
      />
    );
  };
  renderNotesItems = (noteItem: any, index: any) => {
    return (
      <div
        key={index.toString()}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Typography variant="h6" gutterBottom>
          {noteItem.title}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {noteItem.value}
        </Typography>
      </div>
    );
  };
  renderInspectionItems = (inspectionItem: any) => {
    const { classes } = this.props;
    return (
      <div style={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item>
            <ButtonBase
              className={classes.image}
              onClick={() => {
                this.setState({
                  selectImageToView: inspectionItem.imageItem,
                  openViewImage: true,
                });
              }}
            >
              {inspectionItem.imageItem && inspectionItem.imageItem.base64 ? (
                <img
                  className={classes.img}
                  alt="complex"
                  src={`data:image/jpeg;base64,${inspectionItem.imageItem.base64}`}
                />
              ) : (
                <img
                  className={classes.img}
                  alt="complex"
                  src={imagePlacholder}
                />
              )}
            </ButtonBase>
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item>
                <ListItem>
                  <Typography variant="h6" component="h6">
                    {inspectionItem.title}
                  </Typography>
                </ListItem>
                <List dense={true}>
                  {inspectionItem.questions.map((question: any, index: any) => (
                    <React.Fragment key={index.toString()}>
                      <DisplayItemComponent
                        questionItem={question}
                        itemKey={index}
                        handleOnMenuItemClicked={this.handleOnMenuItemClicked}
                      />
                      <Divider style={{ marginBottom: 10 }} />
                    </React.Fragment>
                  ))}
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };
  renderFormsItems = (formsItem: any) => {
    return (
      <div style={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item>
                {formsItem.map((mItem: any, index: any) => {
                  let signatureItem =
                    mItem.responseType === "SIGNATURE"
                      ? mItem.signatureItem
                      : null;
                  return (
                    <div key={index.toString()}>
                      <div>
                        <ListItem>
                          <ListItemText
                            primary={mItem.formsInput}
                            secondary={
                              mItem.value
                                ? mItem.value
                                : signatureItem.who
                                ? signatureItem.who
                                : ""
                            }
                          />
                        </ListItem>
                        {signatureItem && (
                          <Paper>
                            <ListItem
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <ListItemText
                                primary={
                                  signatureItem.value &&
                                  signatureItem.value.fullName
                                    ? signatureItem.value.fullName
                                    : ""
                                }
                                secondary={`Signed On:${getMomentDateTime(
                                  signatureItem.value &&
                                    signatureItem.value.signedOn
                                    ? signatureItem.value.signedOn
                                    : ""
                                )}`}
                              />
                              {signatureItem.value &&
                                signatureItem.value.signatureValue && (
                                  <div>
                                    <IconButton
                                      style={{
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      onClick={() =>
                                        this.handleViewSignature(
                                          signatureItem.value.signatureValue,
                                          signatureItem.value
                                        )
                                      }
                                    >
                                      <EyeViewIcon />
                                    </IconButton>
                                    Open Signature
                                  </div>
                                )}
                            </ListItem>
                          </Paper>
                        )}
                      </div>
                    </div>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };
  render() {
    const { open, handleClose, inspectionData, classes, company } = this.props;
    return (
      <React.Fragment>
        {this.renderSignatureDialog()}
        {this.renderEditDialog()}
        {this.renderViewImageDialog()}
        {inspectionData && inspectionData.inspection && (
          <Dialog
            open={open}
            keepMounted={true}
            onClose={() => handleClose()}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullScreen={true}
            maxWidth={"md"}
          >
            <CssBaseline />
            <ThemeProvider theme={defaultTheme}>
              <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                  <Typography variant="h6" className={classes.title}>
                    Viewing Inspection
                  </Typography>
                  <Button
                    type="submit"
                    onClick={() => handleClose()}
                    color="inherit"
                  >
                    Close
                  </Button>
                </Toolbar>
              </AppBar>
            </ThemeProvider>
            <Drawer
              className={classes.drawer}
              variant="permanent"
              classes={{
                paper: classes.drawerPaper,
              }}
              anchor="left"
            >
              <Divider />
              <div style={{ paddingRight: 20 }}>
                <div
                  style={{
                    padding: 10,
                    flexDirection: "column",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <ListItemText
                    primary={`${inspectionData.inspection.name} - ${inspectionData.inspection.inspectionType}`}
                    secondary={
                      getInspectionLabel(
                        inspectionData.inspection.category,
                        this.props.company.inspectionCategories
                      ).label
                    }
                  />
                  {inspectionData.inspection &&
                  inspectionData.inspection.imageItem &&
                  inspectionData.inspection.imageItem.base64 ? (
                    <ButtonBase
                      focusRipple
                      className={classes.media}
                      onClick={() => {
                        this.setState({
                          selectImageToView:
                            inspectionData.inspection.imageItem,
                          openViewImage: true,
                        });
                      }}
                    >
                      <img
                        className={classes.media}
                        src={`data:image/jpeg;base64,${inspectionData.inspection.imageItem.base64}`}
                        alt={"inspections card"}
                      />
                    </ButtonBase>
                  ) : (
                    <img
                      className={classes.media}
                      src={imagePlacholder}
                      alt={"inspections card2"}
                    />
                  )}
                  <Paper
                    elevation={3}
                    style={{
                      width: "80%",
                      height: 50,
                      margin: 10,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant={"h2"}
                      style={{ fontSize: 18, color: "black" }}
                    >
                      INSPECTOR
                    </Typography>
                  </Paper>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <ImageIcon />
                      </Avatar>
                    </ListItemAvatar>
                    {inspectionData.assign &&
                      inspectionData.assign.assignedTo && (
                        <ListItemText
                          primary={"Assigned to:"}
                          secondary={inspectionData.assign.assignedTo.fullName}
                        />
                      )}
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <CalendarIcon />
                      </Avatar>
                    </ListItemAvatar>
                    {inspectionData.assign && inspectionData.assign.assignedTo && (
                      <Grid
                        container
                        direction="row"
                        justify="space-evenly"
                        alignItems="center"
                      >
                        <ListItemText
                          primary={"Received on:"}
                          secondary={getMomentDate(
                            inspectionData.assign.receivedOn
                          )}
                        />
                        <ListItemText
                          primary={"Completed on:"}
                          secondary={getMomentDate(
                            inspectionData.assign.completionDate
                          )}
                        />
                      </Grid>
                    )}
                  </ListItem>
                  {inspectionData &&
                    inspectionData.inspection &&
                    inspectionData.inspection.signotoriesItems &&
                    inspectionData.inspection.signotoriesItems.length > 0 && (
                      <div style={{ width: "100%" }}>
                        <Paper
                          elevation={3}
                          style={{
                            width: "80%",
                            height: 50,
                            margin: 10,
                            alignSelf: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Typography
                            variant={"h2"}
                            style={{ fontSize: 18, color: "black" }}
                          >
                            SiGNATORIES
                          </Typography>
                        </Paper>
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar>
                              <ImageIcon />
                            </Avatar>
                          </ListItemAvatar>
                          {inspectionData.assign &&
                            inspectionData.assign.assignedTo && (
                              <Grid container direction="column">
                                {inspectionData.inspection.signotoriesItems.map(
                                  (signatureItem: any, index: any) => {
                                    let objBase64 =
                                      signatureItem.value &&
                                      signatureItem.value.signatureValue
                                        ? signatureItem.value.signatureValue
                                        : "";
                                    if (signatureItem.value) {
                                      return signatureItem.value ===
                                        "NOT_SIGNED" ? (
                                        <div>
                                          <Typography>
                                            {convertTextToTitleCase(
                                              signatureItem.who
                                            )}
                                          </Typography>
                                          <Typography
                                            style={{ color: "red" }}
                                            variant={"caption"}
                                          >
                                            No Signature
                                          </Typography>
                                        </div>
                                      ) : (
                                        <div
                                          key={index.toString()}
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          <ListItemText
                                            primary={
                                              signatureItem.value.fullName
                                            }
                                            secondary={`Signed On:${getMomentDateTime(
                                              signatureItem.value.signedOn
                                            )}`}
                                          />
                                          {objBase64 && (
                                            <div>
                                              <IconButton
                                                style={{
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                }}
                                                onClick={() =>
                                                  this.handleViewSignature(
                                                    objBase64,
                                                    signatureItem.value
                                                  )
                                                }
                                              >
                                                <EyeViewIcon />
                                              </IconButton>
                                              Open Signature
                                            </div>
                                          )}
                                        </div>
                                      );
                                    }
                                    return null;
                                  }
                                )}
                              </Grid>
                            )}
                        </ListItem>
                      </div>
                    )}
                </div>
              </div>
            </Drawer>
            <main className={classes.content}>
              <div className={classes.toolbar} />
              <Paper className={classes.tabRoot}>
                {inspectionData.inspection.captureType === "QUESTIONS" ? (
                  <Tabs
                    value={this.state.selectedTab}
                    onChange={this.handleChange}
                    TabIndicatorProps={{
                      style: { background: "orange", height: 3 },
                    }}
                    textColor="primary"
                  >
                    <Tab label="Header Items" value={0} />
                    <Tab label="Inspection Items" value={1} />
                    {inspectionData.inspection.notesItems &&
                      inspectionData.inspection.notesItems.length > 0 && (
                        <Tab label="Summary or Notes" value={2} />
                      )}
                    {inspectionData.inspection.activities &&
                      inspectionData.inspection.activities.length > 0 && (
                        <Tab label="Activity Flow" value={3} />
                      )}
                    {/* <Tab label="Activity Flow" value={3} /> */}
                    {inspectionData.inspection.breakdowns &&
                      inspectionData.inspection.breakdowns.length > 0 && (
                        <Tab label="Breakdowns" value={4} />
                      )}
                    {inspectionData.inspection.standings &&
                      inspectionData.inspection.standings.length > 0 && (
                        <Tab label="Standings" value={5} />
                      )}
                  </Tabs>
                ) : (
                  <Tabs
                    value={this.state.selectedTab}
                    onChange={this.handleChange}
                    TabIndicatorProps={{
                      style: { background: "orange", height: 3 },
                    }}
                    textColor="primary"
                  >
                    <Tab label="Header Items" />
                    <Tab label="Forms Items" />
                  </Tabs>
                )}
              </Paper>
              <TabPanel value={this.state.selectedTab} index={0}>
                {inspectionData.inspection.headerItems.map(
                  (headerItem: any, index: any) => {
                    if (headerItem && headerItem.type && headerItem.title) {
                      return (
                        <ListItem key={index.toString()}>
                          <ListItemAvatar>
                            <Avatar>{this.getIcon(headerItem.type)}</Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={headerItem.title}
                            secondary={
                              headerItem.value
                                ? this.getValueByType(
                                    headerItem.type,
                                    headerItem.value,
                                    headerItem
                                  )
                                : ""
                            }
                          />
                        </ListItem>
                      );
                    } else {
                      return null;
                    }
                  }
                )}
              </TabPanel>
              {inspectionData.inspection.captureType === "QUESTIONS" && (
                <TabPanel value={this.state.selectedTab} index={1}>
                  {inspectionData.inspection.inspectionsItems.map(
                    (inspectionItem: any, index: any) => {
                      return (
                        <React.Fragment key={index.toString()}>
                          {this.renderInspectionItems(inspectionItem)}
                          <Divider variant={"inset"} />
                        </React.Fragment>
                      );
                    }
                  )}
                </TabPanel>
              )}
              {inspectionData.inspection.captureType === "FORMS" && (
                <TabPanel value={this.state.selectedTab} index={1}>
                  {inspectionData.inspection.formsItems.map(
                    (formsItem: any, index: any) => {
                      return (
                        <React.Fragment key={index.toString()}>
                          {this.renderFormsItems(formsItem)}
                          <Divider variant={"inset"} />
                        </React.Fragment>
                      );
                    }
                  )}
                </TabPanel>
              )}

              <TabPanel value={this.state.selectedTab} index={2}>
                {inspectionData.inspection.notesItems &&
                inspectionData.inspection.notesItems.length > 0 ? (
                  <List>
                    {inspectionData.inspection.notesItems.map(
                      (notesItem: any, index: any) => {
                        return this.renderNotesItems(notesItem, index);
                      }
                    )}
                  </List>
                ) : (
                  <div
                    style={{
                      height: 500,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "auto",
                    }}
                  >
                    <img
                      src={emptyTrash}
                      style={{ width: 40, height: 40 }}
                      alt="Empty Trash"
                    />
                    <Typography
                      variant="h5"
                      gutterBottom
                      style={{ marginTop: 10, textAlign: "center" }}
                    >
                      {`Summary Notes`.toUpperCase()}
                    </Typography>
                  </div>
                )}
              </TabPanel>

              <TabPanel value={this.state.selectedTab} index={3}>
                {company.activityFlowLegends && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: 10,
                    }}
                  >
                    {company.activityFlowLegends.map(
                      (activityFlowLegendItem: any, index: any) => (
                        <Chip
                          key={"chi-" + index.toString()}
                          style={{ margin: 10 }}
                          avatar={
                            <Avatar style={{ color: "white" }}>
                              {activityFlowLegendItem.code}
                            </Avatar>
                          }
                          label={activityFlowLegendItem.definition}
                        />
                      )
                    )}
                  </div>
                )}
                <div>
                  {inspectionData.inspection.activities &&
                  inspectionData.inspection.activities.timelines &&
                  inspectionData.inspection.activities.timelines.length > 0 ? (
                    <ActivitiesTableComponent
                      activities={inspectionData.inspection.activities}
                    />
                  ) : (
                    <div
                      style={{
                        height: 500,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "auto",
                      }}
                    >
                      <img
                        src={emptyTrash}
                        style={{ width: 40, height: 40 }}
                        alt="Empty Trash"
                      />
                      <Typography
                        variant="h5"
                        gutterBottom
                        style={{ marginTop: 10, textAlign: "center" }}
                      >
                        {`No Activities`.toUpperCase()}
                      </Typography>
                    </div>
                  )}
                </div>
              </TabPanel>
              <TabPanel value={this.state.selectedTab} index={4}>
                <div>
                  {inspectionData.inspection.breakdowns &&
                  inspectionData.inspection.breakdowns.length > 0 ? (
                    inspectionData.inspection.breakdowns.map(
                      (breakdownItem: any, index: any) => {
                        return (
                          <div
                            key={`breakdownText-${index}`}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Paper
                              style={{
                                width: "100%",
                                height: "100%",
                                margin: 5,
                              }}
                            >
                              <ListItemText
                                style={{ marginLeft: 10 }}
                                primary={"Breakdown Reported"}
                                secondary={breakdownItem.title}
                              />
                              <Divider />
                              <ListItem>
                                <ListItemText
                                  primary={"Time of breakdown"}
                                  secondary={getMomentTime(
                                    breakdownItem["Time of breakdown"]
                                  )}
                                />
                                <ListItemText
                                  primary={"Time breakdown reported"}
                                  secondary={getMomentTime(
                                    breakdownItem["Time breakdown reported"]
                                  )}
                                />
                                <ListItemText
                                  primary={"Time artisan arrived"}
                                  secondary={getMomentTime(
                                    breakdownItem["Time artisan arrived"]
                                  )}
                                />
                                <ListItemText
                                  primary={"Time back in operation"}
                                  secondary={getMomentTime(
                                    breakdownItem["Time back in operation"]
                                  )}
                                />
                              </ListItem>
                              <Divider variant={"middle"} />
                              <ListItem>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    textAlign: "left",
                                  }}
                                >
                                  <Typography className={classes.heading}>
                                    Comments
                                  </Typography>
                                  <Typography
                                    style={{ whiteSpace: "pre-line" }}
                                  >
                                    {breakdownItem.commentsAndSpares &&
                                    breakdownItem.commentsAndSpares.notes
                                      ? breakdownItem.commentsAndSpares.notes
                                      : ""}
                                  </Typography>
                                </div>
                              </ListItem>
                              {breakdownItem.commentsAndSpares &&
                                breakdownItem.commentsAndSpares.spares && (
                                  <div>
                                    <ListItem>
                                      <Typography className={classes.heading}>
                                        {"Spares"}
                                      </Typography>
                                    </ListItem>
                                    <ListItem
                                      style={{
                                        marginLeft: 45,
                                      }}
                                    >
                                      {breakdownItem.commentsAndSpares.spares.map(
                                        (obj: any) => {
                                          return (
                                            <Chip
                                              label={obj}
                                              variant={"outlined"}
                                            />
                                          );
                                        }
                                      )}
                                    </ListItem>
                                  </div>
                                )}

                              {breakdownItem &&
                                breakdownItem.images &&
                                breakdownItem.images.length > 0 && (
                                  <ListItem>
                                    <List
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        padding: 0,
                                      }}
                                    >
                                      {breakdownItem.images.map(
                                        (imageItem: any, vIndex: any) => {
                                          return (
                                            <React.Fragment
                                              key={`${vIndex.toString()}-breakdowns-items`}
                                            >
                                              <ButtonBase
                                                focusRipple
                                                style={{
                                                  width: 80,
                                                  height: 80,
                                                  margin: 5,
                                                }}
                                                onClick={() => {
                                                  this.setState({
                                                    selectImageToView:
                                                      imageItem,
                                                    openViewImage: true,
                                                  });
                                                }}
                                              >
                                                <img
                                                  src={`data:image/jpeg;base64,${
                                                    imageItem.base64
                                                      ? imageItem.base64
                                                      : ""
                                                  }`}
                                                  alt={index.toString()}
                                                  style={{
                                                    width: 80,
                                                    height: 80,
                                                    margin: 5,
                                                  }}
                                                />
                                              </ButtonBase>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </List>
                                  </ListItem>
                                )}
                              <Divider />
                              {breakdownItem && breakdownItem.artisanPersons && (
                                <React.Fragment>
                                  {breakdownItem.artisanPersons.map(
                                    (artisanPerson: any) => {
                                      return (
                                        <React.Fragment>
                                          <ListItem>
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                textAlign: "left",
                                              }}
                                            >
                                              <Typography
                                                className={classes.heading}
                                              >
                                                Artisan
                                              </Typography>
                                            </div>
                                          </ListItem>
                                          {artisanPerson.artisanDetails && (
                                            <ListItem>
                                              <ListItemAvatar>
                                                <Avatar>
                                                  <ImageIcon />
                                                </Avatar>
                                              </ListItemAvatar>
                                              <ListItemText
                                                primary={
                                                  artisanPerson.artisanDetails
                                                    .fullName
                                                    ? artisanPerson
                                                        .artisanDetails.fullName
                                                    : ""
                                                }
                                                secondary={
                                                  artisanPerson.artisanDetails
                                                    .employeeNumber
                                                    ? artisanPerson
                                                        .artisanDetails
                                                        .employeeNumber
                                                    : ""
                                                }
                                              />
                                            </ListItem>
                                          )}

                                          {artisanPerson.artisanCommentsAndSpares && (
                                            <div>
                                              <ListItem>
                                                {"Artisan Comments"}
                                              </ListItem>
                                              {artisanPerson.artisanCommentsAndSpares.map(
                                                (
                                                  artisanItem: any,
                                                  nIndex: any
                                                ) => {
                                                  return (
                                                    <div
                                                      key={`comments-${nIndex.toString()}`}
                                                    >
                                                      <ListItem>
                                                        <ListItemIcon
                                                          style={{ margin: 0 }}
                                                        >
                                                          {nIndex + 1}
                                                        </ListItemIcon>
                                                        <ListItemText
                                                          primary={
                                                            artisanItem.notes
                                                          }
                                                        />
                                                      </ListItem>
                                                      <ListItem>
                                                        <Typography
                                                          className={
                                                            classes.heading
                                                          }
                                                        >
                                                          {"Spares"}
                                                        </Typography>
                                                      </ListItem>
                                                      <ListItem
                                                        style={{
                                                          marginLeft: 45,
                                                        }}
                                                      >
                                                        {artisanItem.spares.map(
                                                          (obj: any) => {
                                                            return (
                                                              <Chip
                                                                label={obj}
                                                                variant={
                                                                  "outlined"
                                                                }
                                                              />
                                                            );
                                                          }
                                                        )}
                                                      </ListItem>
                                                    </div>
                                                  );
                                                }
                                              )}
                                              <Divider />
                                            </div>
                                          )}
                                          {artisanPerson.images &&
                                            artisanPerson.images.length > 0 && (
                                              <ListItem>
                                                <List
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    padding: 0,
                                                  }}
                                                >
                                                  {artisanPerson.images.map(
                                                    (
                                                      imageItem: any,
                                                      mIndex: any
                                                    ) => {
                                                      return (
                                                        <React.Fragment
                                                          key={mIndex.toString()}
                                                        >
                                                          <ButtonBase
                                                            focusRipple
                                                            style={{
                                                              width: 80,
                                                              height: 80,
                                                              margin: 5,
                                                            }}
                                                            onClick={() => {
                                                              this.setState({
                                                                selectImageToView:
                                                                  imageItem,
                                                                openViewImage:
                                                                  true,
                                                              });
                                                            }}
                                                          >
                                                            <img
                                                              src={`data:image/jpeg;base64,${
                                                                imageItem.base64
                                                                  ? imageItem.base64
                                                                  : ""
                                                              }`}
                                                              alt={index.toString()}
                                                              style={{
                                                                width: 80,
                                                                height: 80,
                                                                margin: 5,
                                                              }}
                                                            />
                                                          </ButtonBase>
                                                        </React.Fragment>
                                                      );
                                                    }
                                                  )}
                                                </List>
                                              </ListItem>
                                            )}
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </React.Fragment>
                              )}
                            </Paper>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <div
                      style={{
                        height: 500,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "auto",
                      }}
                    >
                      <img
                        src={emptyTrash}
                        style={{ width: 40, height: 40 }}
                        alt="Empty Trash"
                      />
                      <Typography
                        variant="h5"
                        gutterBottom
                        style={{ marginTop: 10, textAlign: "center" }}
                      >
                        {`No Breakdowns`.toUpperCase()}
                      </Typography>
                    </div>
                  )}
                </div>
              </TabPanel>
              <TabPanel value={this.state.selectedTab} index={5}>
                <div>
                  {inspectionData.inspection.standings &&
                  inspectionData.inspection.standings.length > 0 ? (
                    inspectionData.inspection.standings.map(
                      (standingItem: any, index: any) => {
                        return (
                          <div
                            key={`standingItemText-${index}`}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Paper
                              style={{
                                width: "100%",
                                height: "100%",
                                margin: 5,
                              }}
                            >
                              <ListItemText
                                style={{ marginLeft: 10 }}
                                primary={"Standing"}
                                secondary={standingItem.title}
                              />
                              <Divider />
                              <ListItem>
                                <ListItemText
                                  primary={"Time started standing"}
                                  secondary={getMomentTime(
                                    standingItem["Time started standing"]
                                  )}
                                />
                                <ListItemText
                                  primary={"Time reported"}
                                  secondary={getMomentTime(
                                    standingItem["Time reported"]
                                  )}
                                />
                                <ListItemText
                                  primary={"Time started operating"}
                                  secondary={getMomentTime(
                                    standingItem["Time started operating"]
                                  )}
                                />
                              </ListItem>
                              <Divider variant={"middle"} />
                              <ListItem>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    textAlign: "left",
                                  }}
                                >
                                  <Typography className={classes.heading}>
                                    Comments
                                  </Typography>
                                  <Typography
                                    style={{ whiteSpace: "pre-line" }}
                                  >
                                    {standingItem.comments &&
                                    standingItem.comments.notes
                                      ? standingItem.comments.notes
                                      : ""}
                                  </Typography>
                                </div>
                              </ListItem>
                              {standingItem &&
                                standingItem.images &&
                                standingItem.images.length > 0 && (
                                  <ListItem>
                                    <List
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        padding: 0,
                                      }}
                                    >
                                      {standingItem.images.map(
                                        (imageItem: any, index: any) => {
                                          return (
                                            <React.Fragment
                                              key={index.toString()}
                                            >
                                              <ButtonBase
                                                focusRipple
                                                style={{
                                                  width: 80,
                                                  height: 80,
                                                  margin: 5,
                                                }}
                                                onClick={() => {
                                                  this.setState({
                                                    selectImageToView:
                                                      imageItem,
                                                    openViewImage: true,
                                                  });
                                                }}
                                              >
                                                <img
                                                  src={`data:image/jpeg;base64,${
                                                    imageItem.base64
                                                      ? imageItem.base64
                                                      : ""
                                                  }`}
                                                  alt={index.toString()}
                                                  style={{
                                                    width: 80,
                                                    height: 80,
                                                    margin: 5,
                                                  }}
                                                />
                                              </ButtonBase>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </List>
                                  </ListItem>
                                )}
                            </Paper>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <div
                      style={{
                        height: 500,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "auto",
                      }}
                    >
                      <img
                        src={emptyTrash}
                        style={{ width: 40, height: 40 }}
                        alt="Empty Trash"
                      />
                      <Typography
                        variant="h5"
                        gutterBottom
                        style={{ marginTop: 10, textAlign: "center" }}
                      >
                        {`No Standings`.toUpperCase()}
                      </Typography>
                    </div>
                  )}
                </div>
              </TabPanel>
            </main>
          </Dialog>
        )}
        <LoadingComponents isLoading={this.state.isLoading} />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ViewInspectionDialog);
